import { render, staticRenderFns } from "./PatreonBoosts.vue?vue&type=template&id=24b109ba&scoped=true"
import script from "./PatreonBoosts.vue?vue&type=script&lang=js"
export * from "./PatreonBoosts.vue?vue&type=script&lang=js"
import style0 from "./PatreonBoosts.vue?vue&type=style&index=0&id=24b109ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b109ba",
  null
  
)

export default component.exports